/**
 * The red line a list/board shows when its query failed (Luật 6, AGENTS.md):
 * the server's reason, never an empty state that reads as "nothing here".
 * Kiểm thử đóng vai 17/10/2026 found screens that drew "Không có …" / "0" on a
 * failed load (Lịch chụp, Đơn hàng, Phiếu chờ duyệt, Giám sát QC…).
 */
import { cn } from "@/lib/utils";

export function queryErrorText(error: unknown, fallback: string): string {
  return error instanceof Error && error.message ? error.message : fallback;
}

export function QueryErrorNote({
  error,
  fallback,
  className,
}: {
  error: unknown;
  fallback: string;
  className?: string;
}) {
  return (
    <p role="alert" className={cn("text-sm text-destructive", className)}>
      {queryErrorText(error, fallback)}
    </p>
  );
}
